import { formatCell, rowKey } from "./render.js";
/** The problems of a refusal as one sentence, in the reader's language where the catalogue has it. */
function refusalText(outcome, i18n) {
    if (!outcome.problems?.length)
        return outcome.message;
    return outcome.problems.map((p) => {
        if (!p.key)
            return p.message;
        const said = i18n.t(p.key, p.params);
        return said === p.key ? p.message : said;
    }).join(' ');
}
/**
 * One row's preview answer as a verdict. A 2xx is "applies" unless the answer says `applies: false`
 * (and then its `reason`); a refusal is "does not apply" with the server's reason; anything else —
 * the unit unreachable, a timeout — is "does not apply" too, because a row whose effect nobody could
 * say is a row that would run blind.
 */
export function verdictOf(key, outcome, i18n) {
    if (outcome.state === 'ok') {
        const data = outcome.data && typeof outcome.data === 'object' && !Array.isArray(outcome.data) ? outcome.data : {};
        if (data['applies'] === false) {
            const reason = typeof data['reason'] === 'string' && data['reason'] ? data['reason'] : i18n.t('list.bulk.preview.notApplies');
            return { key, applies: false, reason, data };
        }
        return { key, applies: true, data };
    }
    if (outcome.state === 'rejected')
        return { key, applies: false, reason: refusalText(outcome, i18n) };
    return { key, applies: false, reason: i18n.t(`state.${outcome.state}`) };
}
/** A fresh run: one per confirm dialog opened, never per press. */
export function newRun() {
    const c = globalThis.crypto;
    if (c?.randomUUID)
        return c.randomUUID();
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
/**
 * The key one row's request carries. The same run and the same row give the same key, so a second
 * press — or a retry after an answer was lost — is the same request to a route that remembers keys.
 * At most 120 characters, the length the server helper accepts.
 */
export function idempotencyKey(run, key) {
    return `${run}:${key}`.slice(0, 120);
}
/**
 * What a row is called in a bulk confirm, a report or a removal's confirmation: the screen's card
 * title when it has a card map, else the list's first column — the cell the table itself leads
 * every row with. Formatted as that cell is (a status reads as its word), and the row's key when
 * the cell is empty, so a line is never blank.
 */
export function rowTitle(manifest, row, i18n) {
    const columns = manifest.columns ?? [];
    const column = (manifest.card?.title ? columns.find((c) => c.key === manifest.card.title) : undefined) ?? columns.find((c) => !c.hidden);
    const said = column ? formatCell(row[column.key], column, i18n) : '';
    return said && said !== '—' ? said : rowKey(row);
}
/** How many went through and how many were refused. */
export function reportCounts(report) {
    const refused = report.results.filter((r) => r.refused !== undefined).length;
    return { done: report.results.length - refused, refused };
}
//# sourceMappingURL=bulk.js.map